var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerplayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.17,
    height: 75.17,
    viewBox: "0 0 75.17 75.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pokerplayer",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16993",
    "data-name": "Path 16993",
    d: "M66.8,23.008V21.986a9.551,9.551,0,0,0-5.038-8.41,7.444,7.444,0,0,0,1.32-4.238V7.487a7.487,7.487,0,1,0-14.974,0V9.338a7.444,7.444,0,0,0,1.32,4.238,9.6,9.6,0,0,0-2.835,2.32,9.61,9.61,0,0,0-2.835-2.32,7.444,7.444,0,0,0,1.32-4.238V7.487a7.487,7.487,0,0,0-14.974,0V9.338a7.444,7.444,0,0,0,1.32,4.238,9.6,9.6,0,0,0-2.835,2.32,9.611,9.611,0,0,0-2.835-2.32,7.444,7.444,0,0,0,1.32-4.238V7.487a7.487,7.487,0,0,0-14.974,0V9.338a7.444,7.444,0,0,0,1.32,4.238,9.551,9.551,0,0,0-5.038,8.41v1.021a16.875,16.875,0,0,0,0,29.155v1.021a9.551,9.551,0,0,0,5.038,8.41,7.444,7.444,0,0,0-1.32,4.238v1.851a7.487,7.487,0,0,0,14.974,0V65.832a7.444,7.444,0,0,0-1.32-4.238,9.6,9.6,0,0,0,2.835-2.32,9.61,9.61,0,0,0,2.835,2.32,7.444,7.444,0,0,0-1.32,4.238v1.851a7.487,7.487,0,0,0,14.974,0V65.832a7.444,7.444,0,0,0-1.32-4.238,9.6,9.6,0,0,0,2.835-2.32,9.61,9.61,0,0,0,2.835,2.32,7.444,7.444,0,0,0-1.32,4.238v1.851a7.487,7.487,0,0,0,14.974,0V65.832a7.444,7.444,0,0,0-1.32-4.238,9.551,9.551,0,0,0,5.038-8.41V52.162a16.875,16.875,0,0,0,0-29.155ZM52.508,7.487a3.083,3.083,0,1,1,6.165,0V9.338a3.083,3.083,0,1,1-6.165,0Zm1.42,9.361h3.324A5.148,5.148,0,0,1,62.229,20.7H48.953a5.148,5.148,0,0,1,4.976-3.853ZM34.5,7.487a3.083,3.083,0,1,1,6.165,0V9.338a3.083,3.083,0,1,1-6.165,0Zm1.421,9.361h3.324A5.148,5.148,0,0,1,44.223,20.7H30.947a5.148,5.148,0,0,1,4.976-3.853ZM16.5,7.487a3.083,3.083,0,0,1,6.165,0V9.338a3.083,3.083,0,1,1-6.165,0Zm1.421,9.361h3.324A5.148,5.148,0,0,1,26.217,20.7H12.941a5.148,5.148,0,0,1,4.976-3.853Zm4.745,50.835a3.083,3.083,0,1,1-6.165,0V65.832a3.083,3.083,0,1,1,6.165,0Zm-1.42-9.361H17.917a5.148,5.148,0,0,1-4.976-3.853H26.217a5.148,5.148,0,0,1-4.976,3.853Zm19.426,9.361a3.083,3.083,0,1,1-6.165,0V65.832a3.083,3.083,0,1,1,6.165,0Zm-1.421-9.361H35.923a5.148,5.148,0,0,1-4.976-3.853H44.223A5.148,5.148,0,0,1,39.247,58.322Zm19.426,9.361a3.083,3.083,0,1,1-6.165,0V65.832a3.083,3.083,0,1,1,6.165,0Zm-1.421-9.361H53.929a5.148,5.148,0,0,1-4.976-3.853H62.228a5.148,5.148,0,0,1-4.976,3.853Zm1.033-8.258h-41.4a12.479,12.479,0,1,1,0-24.959h41.4a12.479,12.479,0,1,1,0,24.959Z",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16994",
    "data-name": "Path 16994",
    d: "M88.359,201h4.4v5.946h-4.4Z",
    transform: "translate(-75.386 -171.49)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16995",
    "data-name": "Path 16995",
    d: "M88.359,270.5h4.4v5.946h-4.4Z",
    transform: "translate(-75.386 -230.786)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16996",
    "data-name": "Path 16996",
    d: "M148.359,201h4.4v5.946h-4.4Z",
    transform: "translate(-126.577 -171.49)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16997",
    "data-name": "Path 16997",
    d: "M148.359,270.5h4.4v5.946h-4.4Z",
    transform: "translate(-126.577 -230.786)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16998",
    "data-name": "Path 16998",
    d: "M271,201h4.4v5.946H271Z",
    transform: "translate(-231.213 -171.49)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16999",
    "data-name": "Path 16999",
    d: "M271,270.5h4.4v5.946H271Z",
    transform: "translate(-231.213 -230.786)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17000",
    "data-name": "Path 17000",
    d: "M210,201h4.4v5.946H210Z",
    transform: "translate(-179.169 -171.49)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17001",
    "data-name": "Path 17001",
    d: "M210,270.5h4.4v5.946H210Z",
    transform: "translate(-179.169 -230.786)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17002",
    "data-name": "Path 17002",
    d: "M393.641,201h4.4v5.946h-4.4Z",
    transform: "translate(-335.848 -171.49)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17003",
    "data-name": "Path 17003",
    d: "M393.641,270.5h4.4v5.946h-4.4Z",
    transform: "translate(-335.848 -230.786)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17004",
    "data-name": "Path 17004",
    d: "M333.641,201h4.4v5.946h-4.4Z",
    transform: "translate(-284.657 -171.49)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17005",
    "data-name": "Path 17005",
    d: "M333.641,270.5h4.4v5.946h-4.4Z",
    transform: "translate(-284.657 -230.786)",
    fill: "#b23130"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokerplayer);
export default __webpack_public_path__ + "static/media/pokerplayer.87b1fcaa28d77589ab9ab7c97cd99e35.svg";
export { ForwardRef as ReactComponent };